module.exports = __webpack_public_path__ + "img/api-key-buddy.73310a42.svg";